import './style.scss';
let $banner = null;

export const $info = (opts) => {
  $banner && $banner.$info(opts);
};

$info.clear = () => {
  $banner && ($banner.banners = []);
};

export default {
  data() {
    return {
      banners: [],
    };
  },
  created() {
    $banner = this;
  },
  props: {
    max: {
      type: Number,
      default: 1,
    }
  },
  methods: {
    $info(opts) {
      const bannerItem = this.alertBanner({
        iconClass: 'zm-icon-info',
        iconColor: '#666487',
        type: 'info',
        closable: false,
        ...opts,
      });
      const banners = [...this.banners];
      banners.unshift(bannerItem);
      this.banners = [...banners.slice(0, this.max)];
    },
    alertBanner(opts) {
      const { onClose, iconColor, iconClass, message, ...restProps } = opts;
      const context = {...{ props: { ...restProps }, on: { onClose }}};
      return (
        <zm-alert
          class="banner-container__alert-item"
          { ...context }
        >
          { !!iconClass && <i class={`banner-container__alert-item-icon ${iconClass}`} style={{ color: iconColor}}></i> }
          <span domPropsInnerHTML={message}></span>
        </zm-alert>
      )
    }
  },
  render() {
    return (
      <div class="banner-container">
        { this.banners }
      </div>
    )
  }
}
